import React, { useContext, useState } from 'react';
import styles from './index.less';
import { SelectRoleOrPerson } from '@/components/PeopleRoleSelect/SelectRoleOrMemberModal/SelectRoleOrPerson';
import { PeopleRoleSelectContext } from './context';
import cx from 'classnames';

interface TPeopleRoleSelectContentProps {
  selectWidth?: number;
  onChange?: (value: { id: string; name: string }[]) => void;
}

const PeopleRoleSelectContent: React.FC<TPeopleRoleSelectContentProps> = (props) => {
  const { selectWidth } = props;
  const PeopleRoleSelectContextProps = useContext(PeopleRoleSelectContext);
  const { mode, memberNodes, groupNodes, changeNodes } = PeopleRoleSelectContextProps;
  const [value, setValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  return (
    <div
      className={cx(mode === 'select' && styles.in_select, styles.people_role_select_popup)}
      style={{ width: typeof selectWidth === 'number' ? selectWidth : 'auto' }}
    >
      <SelectRoleOrPerson
        haveRightSide={mode === 'modal'}
        groupNodes={groupNodes}
        setGroupNodes={(tempGroupNodes) => {
          changeNodes('groups', tempGroupNodes);
        }}
        memberNodes={memberNodes}
        setMemberNodes={(tempMemberNodes) => {
          console.log('tempMemberNodes是');
          console.log(tempMemberNodes);
          changeNodes('member', tempMemberNodes);
          // onChange?.(
          //   groupNodes
          //     .map((item) => ({
          //       id: item.id,
          //       name: item.name,
          //     }))
          //     .concat(tempMemberNodes.map((item) => ({ id: item.id, name: item.completeName }))),
          // );
        }}
        value={value}
        onChange={(tempValue: string) => {
          console.log('tempValue是');
          console.log(tempValue);
          setValue(tempValue);
        }}
        searchValue={searchValue}
        onChangeSearchValue={(tempValue: string) => setSearchValue(tempValue)}
        needCustom={true}
      />
    </div>
  );
};
export default PeopleRoleSelectContent;
